import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import RtsScanStore from "./RtsScanStore";
import styles from "./RtsScanModule.styles";

const PackagesList = () => {
  const { scannedData, removeScannedData, eventTypes } = RtsScanStore();

  return (
    <Box>
      <Typography>Total RTS packages : {scannedData.length}</Typography>
      <List dense style={styles.packageList}>
        {scannedData.map((singleData, index) => (
          <ListItem
            key={index}
            secondaryAction={
              <Button
                variant="outlined"
                startIcon={<DeleteIcon />}
                onClick={() => removeScannedData(singleData.uuid)}
              >
                DELETE
              </Button>
            }
          >
            {singleData.imageUrl !== undefined && (
              <>
                <ListItemAvatar>
                  <Avatar
                    variant="square"
                    alt="uploaded_image"
                    src={singleData.imageUrl}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={<>{`${singleData.scanSource}`}</>}
                  secondary={
                    singleData.eventTypeId !== -1
                      ? eventTypes.find(
                          (event) => event.id === singleData.eventTypeId
                        )?.eventDescription
                      : singleData.otherReason
                  }
                />
              </>
            )}
            {singleData.imageUrl === undefined && (
              <ListItemText
                primary={
                  <>
                    {singleData.barcode}, {`${singleData.scanSource}`}
                  </>
                }
                secondary={
                  singleData.eventTypeId !== -1
                    ? eventTypes.find(
                        (event) => event.id === singleData.eventTypeId
                      )?.eventDescription
                    : singleData.otherReason
                }
              />
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
export default PackagesList;
